import React from 'react';

const FieldIsRequiredMark = (props) => {

    return (<span>*</span>);
};

export default FieldIsRequiredMark;

